import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12">
      <Card className="shadow-[var(--shadow-md)] text-center max-w-lg w-full" data-testid="payment-cancel-card">
        <CardContent className="py-12">
          <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle size={32} className="text-white" />
          </div>
          <h2 className="text-2xl font-bold text-[#1F2A37] mb-2" style={{fontFamily:'Space Grotesk'}}>Pagamento annullato</h2>
          <p className="text-muted-foreground mb-6">
            Nessun addebito effettuato. Il tuo appuntamento resta registrato: puoi completare il pagamento in qualsiasi momento da "I Miei Appuntamenti".
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Button onClick={() => navigate('/i-miei-appuntamenti')} className="bg-[#238A92] hover:bg-[#0F5E66] text-white" data-testid="payment-cancel-appointments-btn">I Miei Appuntamenti</Button>
            <Button variant="outline" onClick={() => navigate('/')}>Torna alla Home</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
